const sendSubscriptionToBackEnd = subscription => fetch('https://versitails.herokuapp.com/api/v1/subscribe', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(subscription)
});

export default sendSubscriptionToBackEnd;
